import * as React from 'react';
import { VisibleViolationsWarningContainer } from '../../../VisibleViolationsWarning';
import { ActionButtonsContainer } from '../../../ActionButtons';
import { ServicePickerWidgetContainer } from '../../../microfrontends/ServicePickerWidget';

export const SummaryMobile = () => {
  return (
    <>
      <ServicePickerWidgetContainer />
      <VisibleViolationsWarningContainer />
      <ActionButtonsContainer />
    </>
  );
};
